import { IContext } from "@src/context";
import { faqInteractionEvent } from "./events";
import {
  getPropertyIdFromPage,
  triggerNewPhoneButtonClickEvent,
  triggerNewEnquiryFormButtonClickEvent,
  triggerNewAppointmentButtonClickEvent,
} from "./helpers";
import { isOfficeHours } from "@src/utils/officeHours";
import { getPageCategory } from "@src/utils/helper";
import { generateRecordId } from "./helpers";

export function setupAnalyticListeners(context: IContext) {
  const isOfficeHoursNow = isOfficeHours(context?.locale);

  // GTM push `new_phone_button_click` event
  newPhoneButtonClickListener(isOfficeHoursNow);

  // GTM push `new_enquiry_form_button_click` event
  newEnquiryFormButtonClickListener();

  // GTM push `new_appointment_button_click` event
  newAppointmentButtonClickListener();

  // GTM push `faq_interaction` event
  faqInteractionListener();
}

function newPhoneButtonClickListener(isOfficeHoursNow: boolean) {
  document.addEventListener(
    "click",
    function (e) {
      const target = e.target as HTMLElement;
      const button = target.closest("[data-call-button]") as HTMLElement;
      if (button && isOfficeHoursNow) {
        const propertyId = getPropertyIdFromPage();
        const enquiryType = target.closest(".container-book-visit")
          ? "site_enquiry"
          : document.querySelector(".container-showcase")
          ? getPageCategory() === "parking"
            ? "parking_enquiry"
            : "property_enquiry"
          : document.querySelector(".freestyle-corporate")
          ? "corporate_housing_enquiry"
          : "general_enquiry";
        const recordId = generateRecordId();

        triggerNewPhoneButtonClickEvent({
          enquiryType,
          propertyId,
          recordId,
        });
      }
    },
    { capture: true }
  );
}

function newEnquiryFormButtonClickListener() {
  // don't trigger the event for parking page
  if (getPageCategory() === "parking") {
    return;
  }

  document.addEventListener(
    "click",
    function (e) {
      const target = e.target as HTMLElement;
      // exclude out of office hours call button
      const popupId = target
        .closest('[data-popup-event="popup-open"]:not([data-call-button])')
        ?.getAttribute("data-popup-id");
      if (popupId === "enquiry-form" || popupId === "corporate-form") {
        const propertyId = getPropertyIdFromPage();
        const enquiryType = document.querySelector(".container-showcase")
          ? "property_enquiry"
          : popupId === "corporate-form"
          ? "corporate_housing_enquiry"
          : "general_enquiry";

        triggerNewEnquiryFormButtonClickEvent({
          enquiryType,
          propertyId,
        });
      }
    },
    { capture: true }
  );
}

function newAppointmentButtonClickListener() {
  document.addEventListener(
    "click",
    function (e) {
      const target = e.target as HTMLElement;
      const button = target.closest(
        '[data-popup-id="book-visit"][data-popup-event="popup-open"]'
      ) as HTMLElement;
      if (button) {
        const propertyId = getPropertyIdFromPage();
        if (propertyId) {
          triggerNewAppointmentButtonClickEvent({
            propertyId,
          });
        }
      }
    },
    { capture: true }
  );
}

function faqInteractionListener() {
  /*
    The block needs to be inside the container, it will be triggered before the card toggle because of the event bubbling order.
    1. `data-faq-interaction-event={enquiry_type}` inside the faq container
    2. `data-faq-title={faq_title}` in the card item
    3. `data-faq-toggle` in the card toggle button
  */
  document.querySelectorAll("[data-faq-interaction-event]").forEach((block) => {
    block.addEventListener("click", function (e) {
      const target = e.target as HTMLElement;
      if (
        target.getAttribute("data-faq-toggle") !== null && // click the toggle button
        target.closest("[data-active]") === null // the state before card toggle
      ) {
        const enquiryType =
          block.getAttribute("data-faq-interaction-event") || "";
        const faqTitle =
          target.closest("[data-faq-title]")?.getAttribute("data-faq-title") ||
          "";

        faqInteractionEvent({
          enquiry_type: enquiryType,
          faq_title: faqTitle,
        });
      }
    });
  });
}
